module.exports = __webpack_public_path__ + "static/img/summaryimg.fed65cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summaryimg.png
// module id = f9+s
// module chunks = 1